import React from 'react';
import { Box, ProgressBar as CloudscapeProgressBar } from '@amzn/awsui-components-core';

interface ResolutionBarProps {
  resolved: number;
  total: number;
  label?: string;
  goodPercentage?: number | undefined;
  warningPercentage?: number | undefined;
  dynamic?: boolean;
}

const good_color = '#008A00';
const warning_color = '#FA6F00';
const bad_color = '#DB0000';

const good_percentage = 90;
const warning_percentage = 83;

export const ResolutionBar: React.FC<ResolutionBarProps> = ({
  resolved,
  total,
  label,
  goodPercentage = good_percentage,
  warningPercentage = warning_percentage,
  dynamic = false
}) => {
  const percentage = total > 0 ? Math.round((resolved / total) * 100) : 0;
  const displayLabel = label || `Resolved ${resolved} of ${total} (${percentage}%)`;
  const dynamicColor = percentage < warningPercentage ? bad_color : percentage < goodPercentage ? warning_color : good_color;

  return (
    <Box margin={{ top: 'm' }}>
      <CloudscapeProgressBar
        style={
          dynamic
            ? {
                progressValue: {
                  backgroundColor: `light-dark(${dynamicColor},${dynamicColor})`
                },
                progressPercentage: {
                  color: `light-dark(${dynamicColor},${dynamicColor})`,
                  fontSize: '13px',
                  fontWeight: '600'
                }
              }
            : {}
        }
        value={percentage}
        label={displayLabel}
      />
    </Box>
  );
};
